module.exports = __webpack_public_path__ + "static/blue_screen_glitched_1920x1080-7ddef706b420557dbdf0ae49b50e9067.mp4";